// Main custom script entry.

const PRODUCT_CARD_GROUP_SELECTOR = [
  ".layout-panel-grid",
  ".layout-panel-grid-mobile",
  ".swiper-wrapper",
  ".featured-collection__inner",
  ".featured-collection__wrapper",
  ".product-grid",
].join(", ");

class ProductCardContentHeightSync {
  constructor() {
    this.cardSelector = ".product-card--style-card .product-card__content";
    this.frame = 0;
    this.resizeObserver = null;
    this.handleResize = this.scheduleSync.bind(this);
  }

  init() {
    this.resizeObserver = new ResizeObserver(() => this.scheduleSync());
    this.observeCards();

    window.addEventListener("resize", this.handleResize);
    window.addEventListener("load", this.handleResize);
    document.addEventListener("shopify:section:load", this.handleResize);
    document.addEventListener("shopify:section:reorder", this.handleResize);
    document.addEventListener("recommendations:loaded", () => {
      this.observeCards();
      this.scheduleSync();
    });

    this.scheduleSync();
  }

  observeCards() {
    const cards = document.querySelectorAll(this.cardSelector);
    cards.forEach((card) => this.resizeObserver?.observe(card));
  }

  scheduleSync() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.sync());
  }

  sync() {
    const containers = document.querySelectorAll(PRODUCT_CARD_GROUP_SELECTOR);

    containers.forEach((container) => {
      const cards = Array.from(container.querySelectorAll(":scope > .f-column .product-card--style-card .product-card__content, :scope > .swiper-slide .product-card--style-card .product-card__content, :scope > .product-recommendations__item .product-card--style-card .product-card__content"));

      if (cards.length < 2) {
        cards.forEach((card) => {
          card.style.minHeight = "";
        });
        return;
      }

      let maxHeight = 0;
      cards.forEach((card) => {
        card.style.minHeight = "";
      });

      cards.forEach((card) => {
        maxHeight = Math.max(maxHeight, card.offsetHeight);
      });

      if (!maxHeight) return;

      cards.forEach((card) => {
        card.style.minHeight = `${maxHeight}px`;
      });
    });
  }
}

class AddonProductPrice {
  init() {
    document.querySelectorAll("[data-addon-product-price]").forEach((element) => {
      this.updatePrice(element);
    });

    document.addEventListener("shopify:section:load", (event) => {
      event.target.querySelectorAll?.("[data-addon-product-price]").forEach((element) => {
        this.updatePrice(element);
      });
    });
  }

  async updatePrice(element) {
    const { variantId } = element.dataset;
    if (!variantId) return;

    try {
      const response = await fetch(`/variants/${variantId}.js`);
      if (!response.ok) return;

      const variant = await response.json();
      element.textContent = ` ($${Number(variant.price / 100).toString()})`;
      element.dataset.priceCents = String(variant.price);
      document.dispatchEvent(
        new CustomEvent("product:addon-price-updated", {
          detail: { variantId: String(variant.id), price: variant.price },
        })
      );
    } catch (error) {
      // The add-on remains usable if Shopify's variant endpoint is unavailable.
    }
  }
}

new ProductCardContentHeightSync().init();
new AddonProductPrice().init();
